import React, {useState} from "react";
import {Box, Button, Columns, Form, Heading, Pagination, Table} from "react-bulma-components";
import {usePartOrdersData} from "../../hooks/usePartOrdersData";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getDepartmentsData, getPartOrdersData} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import PartOrderRow from "./PartOrderRow";
import SearchBar from "../Utils/SearchBar";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import useSelect from "../../hooks/useSelect";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {NotificationManager} from "react-notifications";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import FigureSummary from "../Figures/FigureSummary";


export default function PartOrderView(props){
    const dispatch = useDispatch();
    const dataFresh = useSelector(getDataFresh);

    const [searchText , setSearchText] = useState();
    const [currentSearch, setCurrentSearch] = useState();
    const [page, setPage] = useState(1);
    const [filters, setFilters] = useState({});
    const [selectedDepartment, setSelectedDepartment] = useState("BLANK");

    const viewOptions = [
        {name:"ORDERS", value: "orders"},
        {name:"QUOTES", value: "quotes"},
        {name:"COMPLETE", value: "complete"},
        {name:"ENQUIRY", value: "enquiry"}
    ];

    const [view, viewInput, setView] = useSelect({
        label: "View",
        options: viewOptions,
        initialValue: "orders"
    });

    const handleSearch = () => {
        setPage(1);
        setCurrentSearch(searchText);
    };

    const clear = () => {
        setSearchText("");
        setCurrentSearch("");
        setPage(1);
    };


    const onDelete = data => {
        const conf = {
            url: props.endpoint+`partorder/${data.id}`,
            method: "delete"
        };
        axios(conf).then(res => {
            setPage(1);
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            NotificationManager.error("There was an error deleting that part order")
        })
    }

    const onDepartmentChange = e => {
        setSelectedDepartment(e.target.value)
    }


    let params = {page: page}
    if(currentSearch){
        params.search = currentSearch;
    }
    if(view){
        params.view = view
    }
    if(selectedDepartment){
        params.department = selectedDepartment
    }
    for (let filter in filters) {
        if (filters[filter][0] && filters[filter][0][filter]) {
          params[filter] = filters[filter][0][filter];
        }
    }

    const loaded = usePartOrdersData(params, dataFresh);
    const departmentsLoaded = useDepartmentsData({}, dataFresh);
    let data = useSelector(getPartOrdersData);
    const departments = useSelector(getDepartmentsData);


    const headings = [
        {
            label: "Part Order Number",
            show: true
        },
        {
            label: "Date Created",
            date: true,
            show: true
        },
        {
            label: "Customer",
            field: "customer",
            labelField: "customer__display_name",
            show: true
        },
        {
            label: "Customer Registration",
            show: true
        },
        {
            label: "Customer VIN",
            show: true
        },
        {
            label: "Order Number",
            show: true
        },
        {
            label: "Description",
            show: true
        },
        {
            label: "Status",
            show: true
        },
        {
            label: "Date/Time Created",
            show: true
        },
        {
            label: "",
            show: view !== "complete"
        }
    ]




    if(!loaded || !departmentsLoaded){
        return (<LoadingSpinner/>)
    }



    return (
        <Box>
            <Heading>Part Orders</Heading>
            <Columns>
                <Columns.Column>
                    <Form.Label invisible={true}>BLANK</Form.Label>
                    <SearchBar
                        searchText={searchText}
                        setSearchText={setSearchText}
                        handleSearch={handleSearch}
                        clear={clear}
                    />
                </Columns.Column>
                {viewInput}
                <Columns.Column>
                    <DepartmentSelector
                        value={selectedDepartment}
                        options={departments}
                        onChange={onDepartmentChange}
                        blank={true}
                        editable={true}
                        label={"Department"}
                        name={"department"}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label invisible={true}>BLANK</Form.Label>
                    <Form.Field>
                      <Form.Control>
                        <Button
                          onClick={() => props.history.push("/editpartorder")}
                          color="success"
                          className="is-pulled-right"
                        >
                          New Part Order +
                        </Button>
                      </Form.Control>
                    </Form.Field>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <FigureSummary selectedDepartment={selectedDepartment}/>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Table size={"fullwidth"}>
                        <thead>
                            <tr>
                                {headings.map(heading => {
                                    if (!heading.field && heading.show) {
                                      return <th key={heading.label}>{heading.label}</th>;
                                    }
                                    if (heading.blank) {
                                      return (
                                        <FilterBlankHeading
                                          key={heading.label}
                                          heading={heading}
                                          setFilters={f => {
                                            setPage(1);
                                            setFilters(f);
                                          }}
                                          filters={filters}
                                        />
                                      );
                                    }
                                    if(heading.show) {
                                        return (
                                            <FilterHeading
                                                key={heading.label}
                                                heading={heading}
                                                setFilters={f => {
                                                    setPage(1);
                                                    setFilters(f);
                                                }}
                                                filters={filters}
                                                options={data.filter_list[heading.field]}
                                            />
                                        );
                                    }
                                  })}
                            </tr>
                        </thead>
                        <tbody>
                        {data.results.map(item => (
                            <PartOrderRow
                                partOrder={item}
                                onDelete={onDelete}
                                view={view}
                            />
                        ))}
                        </tbody>
                    </Table>
                    <Pagination
                        showFirstLast={true}
                        onChange={setPage}
                        current={page}
                        total={Math.ceil(data.count / 25)}
                     ></Pagination>
                </Columns.Column>
            </Columns>
        </Box>
    )


}